const Conduct = () => import(/* webpackChunkName: "Conduct" */ "@/views/conduct/Conduct");
const CodeList = () => import(/* webpackChunkName: "Code List" */ "@/views/conduct/CodeList");
const CodeEdit = () => import(/* webpackChunkName: "Code Edit" */ "@/views/conduct/CodeEdit");
// const BenefitsNew = () => import(/* webpackChunkName: "Benefits New" */ "@/views/benefits/BenefitsNew");

const conductRoutes = [
  {
    path: "conduct",
    name: "Conduct",
    redirect: {
      name: "Code List"
    },
    component: Conduct,
    children: [
      {
        path: "list",
        name: "Code List",
        component: CodeList
      },
      // {
      //   path: "new",
      //   name: "Benefits New",
      //   component: BenefitsNew
      // },
      {
        path: "edit/:id",
        name: "Code Edit",
        component: CodeEdit,
        props: true
      }
    ]
  }
];

export default conductRoutes;